import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { PushPin, Heart } from "phosphor-react";
import Button from "components/Button";
import "./index.scss";

const StarredFarms = ({ farms, redirectTo }) => {
  const favoriteFarms = farms.slice(0, 10).map((item) => item);
  return (
    <section className="starred-farm" data-testid="starred-farms">
      <div className="headline">
        <PushPin size={20} color="#8A8E99" />
        <p className="title">My favorites</p>
      </div>
      {favoriteFarms?.length > 0 ? (
        favoriteFarms?.map((farm) => {
          return (
            <Link
              key={farm?.properties?.farm_name}
              className="list-item"
              to={() => `/farms/${farm?.properties?.farm_id}`}
            >
              {farm?.properties?.farm_name}
              {/* <p className="weather">11m</p> */}
            </Link>
          );
        })
      ) : (
        <div className="starred-blank">
          <p className="text">
            You can assign your favorite farms by clicking on the{" "}
            <Heart size={20} /> icon.{" "}
            <a href="/farms" className="link">
              View farms.
            </a>
          </p>
        </div>
      )}
      {farms?.length > 10 && (
        <Button
          label="View more"
          onClick={redirectTo}
          color="white"
          type="ghost"
          block
        >
          View more
        </Button>
      )}
    </section>
  );
};
StarredFarms.propTypes = {
  farms: PropTypes.oneOfType([PropTypes.array]).isRequired,
  redirectTo: PropTypes.func.isRequired,
};
export default StarredFarms;
